import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromBasketRaffle from './basketRaffle.reducer';

export const selectBasketRaffleState = createFeatureSelector<fromBasketRaffle.State>(
    fromBasketRaffle.basketRaffleFeatureKey
);

export const selectBasketRaffleItemList = createSelector(
    selectBasketRaffleState,
  (state: fromBasketRaffle.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.map(entities, (data, index) => {
      return { data, index };
    })
  }
);
